import { render, staticRenderFns } from "./MobilePage.vue?vue&type=template&id=b5f62ba8&scoped=true"
import script from "./MobilePage.vue?vue&type=script&lang=ts"
export * from "./MobilePage.vue?vue&type=script&lang=ts"
import style0 from "./MobilePage.vue?vue&type=style&index=0&id=b5f62ba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f62ba8",
  null
  
)

export default component.exports